import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import useLocationsWithFocusArea from "../../hooks/useLocationsWithFocusArea";
import useLocationsWithGlobalFilters from "../../hooks/useLocationsWithGlobalFilters";
import { useLocationStore } from "../../index";
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import ILocation from "../../interfaces/ILocation";
import EntitiesDelete from "../EntitiesDelete";
import gridStyles from "../Grid.module.css";
import AddLocationIcon from "../icons/AddLocationIcon";
import DeleteIcon from "../icons/DeleteIcon";
import AddLocations from "../locations/AddLocations";
import LocationsGrid from "../locations/LocationsGrid";

function CompanyDetailsLocationsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { id } = useParams();
    const locationStore = useLocationStore();
    const locations = useLocationsWithFocusArea(useLocationsWithGlobalFilters(
        useMemo(() => computed(() => locationStore.locations.filter(l => l.pipedriveCompanyId.toString() === id)), [id, locationStore.locations]).get()
    ));
    const [isAddLocationsWindowOpen, setIsAddLocationsWindowOpen] = useState(false);
    const [selectedLocations, setSelectedLocations] = useState<ILocation[]>([]);
    const [isLocationsDeleteWindowOpen, setIsLocationsDeleteWindowOpen] = useState(false);

    useEffect(() => setSelectedLocations([]), [id]);
    useEffect(() => setEntityCount(locations.length), [locations]);

    const deleteSelectedLocations = async () => {
        await locationStore.deleteLocations(selectedLocations.map(l => l.id));
        setSelectedLocations([]);
    }

    if (!visible)
        return null;

    return (
        <div>
            <LocationsGrid
                locations={locations}
                controls={[
                    <button key="delete" className={gridStyles.control} onClick={() => selectedLocations.length && setIsLocationsDeleteWindowOpen(true)} disabled={!selectedLocations.length}>
                        <DeleteIcon /> Delete
                    </button>,
                    <button key="add" className={gridStyles.control} onClick={() => setIsAddLocationsWindowOpen(true)}>
                        <AddLocationIcon /> Add
                    </button>
                ]}
                setSelectedLocations={setSelectedLocations}
            />
            {isAddLocationsWindowOpen && (
                <AddLocations
                    companyId={Number(id)}
                    onClose={() => setIsAddLocationsWindowOpen(false)}
                />
            )}
            {isLocationsDeleteWindowOpen && (
                <EntitiesDelete
                    entityName={`Location${selectedLocations.length > 1 ? "s" : ""}`}
                    entityCount={selectedLocations.length}
                    onCancel={() => setIsLocationsDeleteWindowOpen(false)}
                    onDelete={() => {
                        deleteSelectedLocations();
                        setIsLocationsDeleteWindowOpen(false);
                    }}
                />
            )}
        </div>
    );
}

export default observer(CompanyDetailsLocationsTab);